<template>
  <div class="verification-form__wrap">
      <form novalidate class="verification-form" @submit.prevent="submit">
        <md-progress-bar md-mode="indeterminate" v-if="isPending"/>

        <div class="text_large verification-form__title">{{ i18n.kyc_account_verification() }}</div>
          <md-steppers md-linear :md-active-step.sync="activeStep">
            <md-step v-for="(step, i) in steps"
                     :key="i"
                     :id="step.name"
                     :md-label="step.label"
                     :md-done.sync="step.done"
            >
              <component :is="step.component"
                         :schema="step.schema"
                         :activeStep="activeStep"
                         :finalStep="finalStep"
                         :kyc="kyc"
                         @kyc-update="handleKycUpdate($event, { step, i })"
                         @kyc-edit-end="handleKycEditEnd"
              />
            </md-step>
          </md-steppers>
      </form>
  </div>
</template>

<script>
  import FormMixin from '@com/mixins/form.mixin'
  import FileField from '@com/fields/FileField'
  import steps from '../spec/kyc-steps.general.schema'

  import { mapGetters, mapActions } from 'vuex'
  import { ErrorHandler } from '@js/errors/error_handler'
  import { EventDispatcher } from '@js/events/event_dispatcher'
  import { vuexTypes } from '@vuex/types'
  import { i18n } from '@js/i18n'

  import { KycTemplateParser } from '../spec/kyc-template-parser'
  import { accountsService } from '@api/accounts.service'

  import { userTypes, blobTypes, ACCOUNT_TYPES, ACCOUNT_STATES } from '@const'
  import { confirmAction } from '@js/modals/confirmation_message'

  const KYC_LEVEL_TO_SET = 0

  export default {
    name: 'verification-individual',
    mixins: [FormMixin],
    components: { FileField },
    data: _ => ({
      kyc: null,
      activeStep: steps[0].name,
      finalStep: steps[steps.length - 1].name,
      i18n,
      steps,
      ACCOUNT_STATES,
      userTypes
    }),
    created () {
      this.kyc = KycTemplateParser.fromTemplate(this.accountKycData, userTypes.general)
    },
    computed: {
      ...mapGetters([
        vuexTypes.accountLatestBlobId,
        vuexTypes.accountId,
        vuexTypes.accountKycData,
        vuexTypes.accountKycDocuments,
        vuexTypes.accountState,
        vuexTypes.accountKycLatestRequest,
        vuexTypes.accountTypeI
      ]),
      verificationKey () {
        return this.accountId.slice(1, 6)
      }
    },
    methods: {
      ...mapActions({
        loadKycRequests: vuexTypes.GET_ACCOUNT_KYC_REQUESTS,
        updateDocuments: vuexTypes.UPDATE_ACCOUNT_KYC_DOCUMENTS,
        updateKycData: vuexTypes.UPDATE_ACCOUNT_KYC_DATA
      }),

      handleKycUpdate ({ form, documents, finalize }, { step, i }) {
        form = form || {}
        documents = documents || {}
        Object.entries(form).forEach(([key, value]) => {
          this.kyc[key] = value
        })
        Object.entries(documents).forEach(([key, value]) => {
          this.kyc.documents[key] = value
        })
        if (finalize && this.activeStep === steps[steps.length - 1].name) {
          this.handleKycEditEnd()
        }
        step.done = true
        this.activeStep = (this.steps[i + 1] || this.steps[0]).name
      },
      async handleKycEditEnd () {
        if (!await confirmAction()) return
        this.disable()
        try {
          await this.updateDocuments(this.kyc.documents)
          const blobId = await this.updateKycData({
            details: KycTemplateParser.toTemplate(this.kyc, userTypes.general),
            documents: KycTemplateParser.getSaveableDocuments(this.kyc.documents),
            blobType: blobTypes.kycForm.str
          })
          await this.submitRequest(blobId)
          await this.loadKycRequests()
          EventDispatcher.dispatchShowSuccessEvent(i18n.kyc_upload_success())
          this.$router.push({name: 'verification.make', params: {}})
        } catch (error) {
          this.enable()
          console.error(error)
          ErrorHandler.processUnexpected(error)
        }
        this.enable()
      },
      async submitRequest (blobId) {
        await accountsService.createKycRequest({
          requestID: this.accountState === ACCOUNT_STATES.rejected ? this.accountKycLatestRequest.id : '0',
          accountToUpdateKYC: this.accountId,
          accountTypeToSet: ACCOUNT_TYPES.general,
          kycLevelToSet: KYC_LEVEL_TO_SET,
          kycData: { blob_id: blobId }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import './verification.scss';
  @import '~scss/variables';
  @import '~scss/mixins';

</style>



// WEBPACK FOOTER //
// src/vue/app/verification/make/Verification.Individual.vue